import { render, staticRenderFns } from "./FieldTextarea.vue?vue&type=template&id=ff7b28d4&lang=pug&"
import script from "./FieldTextarea.vue?vue&type=script&lang=ts&"
export * from "./FieldTextarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports